import React from "react";

import styles from './index.module.css';

const CONSENT_KEY = 'kf_cookie_consent';

declare global {
    interface Window {
        gtag?: (...args: any[]) => void;
        __kfStartTvSquared?: () => void;
    }
}

function getStoredConsent(): string | null {
    try {
        return localStorage.getItem(CONSENT_KEY);
    } catch (e) {
        return null;
    }
}

export default class CookieConsent extends React.Component {
    state = {
        visible: getStoredConsent() === null
    }

    private storeConsent(value: 'accepted' | 'declined') {
        try {
            localStorage.setItem(CONSENT_KEY, value);
        } catch (e) { }
    }

    private onAccept = () => {
        this.storeConsent('accepted');

        if (window.gtag) {
            window.gtag('consent', 'update', { 'analytics_storage': 'granted' });
        }
        if (window.__kfStartTvSquared) {
            window.__kfStartTvSquared();
        }

        this.setState({ visible: false });
    }

    private onDecline = () => {
        this.storeConsent('declined');
        this.setState({ visible: false });
    }

    render() {
        if (!this.state.visible) return null;

        return (
            <div className={styles.container} role="dialog" aria-label="Cookie consent">
                <div className={styles.message}>
                    We use cookies to analyze site traffic and improve your experience.
                    By clicking &ldquo;Accept&rdquo; you consent to our use of analytics cookies.
                    See our <a className={styles.link} href="/privacy-policy">Privacy Policy</a> for details.
                </div>
                <div className={styles.actions}>
                    <button className={styles.decline} onClick={this.onDecline}>Decline</button>
                    <button className={styles.accept} onClick={this.onAccept}>Accept</button>
                </div>
            </div>
        );
    }
}
